import api from '@lib/api'
import { useMutation, UseMutationOptions, useQuery, UseQueryOptions } from '@tanstack/react-query'

export function useGet<TData = unknown>(
	key: (string | number)[],
	url: string,
	options?: Omit<UseQueryOptions<TData>, 'queryKey' | 'queryFn'>,
) {
	return useQuery<TData>({
		queryKey: key,
		queryFn: async () => {
			const { data } = await api.get<TData>(url)
			return data
		},
		...options,
	})
}

export function usePost<TVars = unknown, TData = unknown>(
	url: string,
	options?: UseMutationOptions<TData, unknown, TVars>,
) {
	return useMutation<TData, unknown, TVars>({
		mutationFn: async (vars: TVars) => {
			const { data } = await api.post<TData>(url, vars)
			return data
		},
		...options,
	})
}

export function usePut<TVars = unknown, TData = unknown>(
	url: string,
	options?: UseMutationOptions<TData, unknown, TVars>,
) {
	return useMutation<TData, unknown, TVars>({
		mutationFn: async (vars: TVars) => {
			const { data } = await api.put<TData>(url, vars)
			return data
		},
		...options,
	})
}

export function useDelete<TVars = unknown, TData = unknown>(
	url: string,
	options?: UseMutationOptions<TData, unknown, TVars>,
) {
	return useMutation<TData, unknown, TVars>({
		mutationFn: async (vars: TVars) => {
			const { data } = await api.delete<TData>(url, { data: vars as any })
			return data
		},
		...options,
	})
}
